<style lang="stylus" scoped>
.main
  margin-top:80px;
  .page
    min-height:calc(100vh - 430px);
    max-width:1980px;
    min-width: 1500px;
  .help-icon
    cursor:pointer;
    position: fixed;
    bottom: 110px;
    right:35px;
    z-index: 2000;
    .help-img
      width:68px;
      height:68px;
</style>

<template>
  <div class="main">
    <vheader></vheader>
      <router-view class="page" />
    <vfooter></vfooter>

    <!-- //私信 -->
    <chat v-if="$store.state.currentSide == 'chat'"></chat>

    <bindPhone></bindPhone>
    <div class="help-icon" title="帮助中心" @click="$router.push({path: '/help'})">
      <img src="/static/img/help_icon.png" class="help-img">
    </div>
  </div>
</template>

<script>
import vheader from "@/components/common/header";
import vfooter from "@/components/common/footer";
import bindPhone from '@/components/login/bindPhone';
import chat from '@/components/chat/chat';

export default {
  name:'Main',
  data() {
    return {

    }
  },
  components: {vheader, vfooter,bindPhone,chat},
  directives: {

  },
  computed: {
    // loginStatus() {
    //   return this.$store.state.loginStatus;
    // }
  },
  beforeCreate() {

  },
  created() {
    //是否是微信用户
    this.$http.get('isWxUser').then((res) =>{
      // console.log('isWxUser',res);
      if(res.data.data.wxUser){
        this.$store.commit('changeLoginModalStatus', {display: true, type: 'weixin'});
        this.$store.commit('changeWxUser',true);
      }else{
        this.$store.commit('changeWxUser',false);
      }
    }).catch(error =>{
      console.log('error',error);
    });
  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  activated() {

  },
  methods: {

  },
  watch: {
    // loginStatus(v, ov) {
    //  if( v ){
    //    // 未绑定微信 跳去绑定微信页面
    //    if( !this.$store.state.mineInfo.wechat ){
    //      this.$gotov1('');
    //    }
    //  }
    // }
  },
  filters: {

  },
}
</script>


// WEBPACK FOOTER //
// src/components/main.vue